// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchFilters-cls1_yEo","cls2":"SearchFilters-cls2_5OX SearchFilters-cls1_yEo","marginBottom":"SearchFilters-marginBottom_Ipt"};